import {API_GATEWAY} from '/constants/API_constants.js';

export async function insertImageValue(img, picPath) {
    img.src = await createImageUrl(picPath);

    img.onerror = async () => {
        
        const url = await getFilesUrl();
        img.src = url + picPath;
        
        img.onerror = () => {
            img.src = imgError();
        }
    };
}

export async function createImageUrl(picPath) {
    let url = localStorage.getItem('branchof_config_files_url');
    if(url===null || url===undefined) {
        
        url = await getFilesUrl();
    }

    return (url + picPath);
}

let configFetchPromise = null;

async function getFilesUrl() {

    if(configFetchPromise) {
        return await configFetchPromise;
    }

    configFetchPromise = fetch(API_GATEWAY + 'config/frontend/image-link')
        .then(res => res.text())
        .then(url => {
            console.log("Fetched config URL:", url);
            localStorage.setItem('branchof_config_files_url', url);
            return url;
        });

    const url = await configFetchPromise;
    

    localStorage.setItem('branchof_config_files_url', url);

    return await url;
}

function imgError() {
    return '/images/logo/logo3_smooth.png';
}